import React from 'react'

const DEFAULT_DATA = [
    { title: 'Total Page Render', value: '-', backgroundColor: '#815ECC', color: '#fff' },
    { title: 'Chat Opens', value: '-', backgroundColor: '#F2B75A', color: '#000' },
    { title: 'Chat Interaction', value: '-', backgroundColor: '#DE8D96', color: '#000' },
    { title: 'Leads Collected', value: '-', backgroundColor: '#1D1D1D', color: '#fff' },
];

const Card = ({ title, value, backgroundColor, color, wrapperStyles }) => {
    return (
        <div style={{
            flex: 1, padding: '12px 20px', backgroundColor, color, display: 'flex', flexDirection: 'column',
            alignItems: 'flex-start', borderRadius: '10px', margin: '0 20px 0px 0px', ...wrapperStyles
        }}>
            <span style={{ fontSize: '18px', fontWeight: 300 }}>{title}</span>
            <span style={{ fontSize: '34px', fontWeight: 500, marginTop: '5px' }}>{value}</span>
        </div>
    )
}

const StatCards = ({ cardsData }) => {
    return (
        <div style={{
            width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between',
            margin: '20px 0px 0px 0px'
        }}>
            {(cardsData || DEFAULT_DATA).map((card, index) => (
                <Card key={index} title={card.title} value={card.value} backgroundColor={card.backgroundColor} color={card.color}
                    wrapperStyles={index === (cardsData || DEFAULT_DATA).length - 1 ? { margin: 0 } : {}} />
            ))}
        </div>
    )
}

export default StatCards